import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('emulator', ['hasSettingChange', 'validPurview']),
        designer() {
            return window.__EMULATOR_DESIGNER__
        },
        currentDocument() {
            return this.designer?.project?.currentDocument || {}
        },
        hasDocumentChange() {
            return this.currentDocument?.hasChange
        },
        hasChange() {
            return this.hasDocumentChange || this.hasSettingChange
        },
        canEditablePage() {
            const { pages: pagesPurview } = this.validPurview || {}
            const document = this.getCurrentDocument()
            return !document?.isTenantProject
                || document?.isTenant
                || (Array.isArray(pagesPurview) && pagesPurview.find(item => item.id === document.id && item?.operateType?.includes('update')))
        },
    },
    beforeRouteLeave(to, from, next) {
        // 系统级的错误优先执行
        if (to.meta?.isErrorPage) {
            next()
            return
        }
        if (this.canEditablePage && this.hasChange) {
            this.$confirm('有未保存的内容，离开前是否保存?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '不保存',
                type: 'warning',
            }).then(() => {
                this.$EMULATOR_EVENT.$emit('save:meta', (data, errMsg) => {
                    if (data !== null && errMsg) {
                        this.$message.error(errMsg)
                    }
                    next()
                })
            }).catch(action => {
                if (action === 'cancel') {
                    this.$EMULATOR_EVENT.$emit('reset:meta')
                    next()
                }
            })
        } else {
            next()
        }
    },
    methods: {
        /**
         * @return {DomainDocument}
         */
        getCurrentDocument() {
            const designer = this.designer || window.__EMULATOR_DESIGNER__
            return designer?.project?.currentDocument
        },

        getDesignerHasChange() {
            const document = this.getCurrentDocument()
            return  document?.hasChange || this.hasSettingChange
        },
    },
}
